export default {
  en: {
    title: 'Topics'
  },
  es: {
    title: 'Temas'
  }
};
